import React from 'react'

import { oneOf, node, string } from 'prop-types'

function PromoCardWrapper({ children, href = null, variant }) {
  if (href) {
    return (
      <a
        href={href}
        className={`promo-card promo-card--${variant}`}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        {children}
      </a>
    )
  }
  return <div className={`promo-card promo-card--${variant}`}>{children}</div>
}

PromoCardWrapper.propTypes = {
  children: node.isRequired,
  href: string,
  variant: oneOf(['sale', 'free']).isRequired,
}

export default PromoCardWrapper
